if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls, RichText } = window.wp.editor;
    const { PanelBody, Button, TextControl } = window.wp.components;

    registerBlockType('custom-gutenberg/tour-details', {
        title: 'Tour Details',
        description: 'Editable tour facts with additional fields for hiking tours.',
        icon: 'list-view',
        category: 'custom-content',
        example: {},

        attributes: {
            title: { type: 'string', default: 'DETALJI TURE' },
            fields: {
                type: 'array',
                default: [
                    { label: 'Trajanje', value: '' },
                    { label: 'Cijena', value: '' },
                    { label: 'Polazak', value: '' }
                ]
            }
        },

        edit({ attributes, setAttributes }) {
            const { title, fields } = attributes;

            function onFieldChange(index, name, value) {
                setAttributes({ fields: fields.map((field, i) => i === index ? { ...field, [name]: value } : field) });
            }

            return ([
                <InspectorControls key="settings">
                    <PanelBody title="Tour fields">
                        { fields.map((field, index) => (
                            <div key={ index }>
                                <TextControl label={ 'Field ' + (index + 1) } value={ field.label } onChange={ label => onFieldChange(index, 'label', label) } />
                                <Button className="button" onClick={ () => setAttributes({ fields: fields.filter((item, i) => i !== index) }) }>Remove field</Button>
                            </div>
                        )) }
                        <Button className="button" onClick={ () => setAttributes({ fields: [...fields, { label: '', value: '' }] }) }>Add field</Button>
                    </PanelBody>
                </InspectorControls>,
                <div key="preview" className="tour-details">
                    <RichText tagName="span" className="eyebrow" value={ title } placeholder="Detalji ture" onChange={ title => setAttributes({ title: title }) } />
                    <dl className="object-facts mb-0">
                        { fields.map((field, index) => (
                            <div key={ index }>
                                <RichText tagName="dt" value={ field.label } placeholder="Naziv polja" onChange={ label => onFieldChange(index, 'label', label) } />
                                <RichText tagName="dd" value={ field.value } placeholder="Vrijednost" onChange={ value => onFieldChange(index, 'value', value) } />
                            </div>
                        )) }
                    </dl>
                </div>
            ]);
        },

        save({ attributes }) {
            return (
                <div className="tour-details">
                    <span className="eyebrow"><RichText.Content value={ attributes.title } /></span>
                    <dl className="object-facts mb-0">
                        { attributes.fields.map((field, index) => (
                            <div key={ index }>
                                <RichText.Content tagName="dt" value={ field.label } />
                                <RichText.Content tagName="dd" value={ field.value } />
                            </div>
                        )) }
                    </dl>
                </div>
            );
        }
    });
}
